var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex w-100"},[_c('div',{staticClass:"d-flex w-100"},[_c('div',{staticClass:"col-md-3"},[_c('inqueryQmaFilter',{attrs:{"qma":_vm.qma},on:{"search":_vm.search}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('inqueryQmaTable',{ref:"inqueryQmaTable",attrs:{"qma":_vm.qma}})],1)])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a8ac57e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/qma/inqueryQma/inqueryQmaLv/inqueryQmaLv.vue
// module id = null
// module chunks = 